export default __webpack_public_path__ + "static/media/Jai Chaudhary_ Event Management Lead.7fe97868.jpg";